import React, { useState } from 'react'
import PageLayout from '../../../shared/ui/layouts/PageLayout/PageLayout'
import { StickyFilterBar } from '../../../shared/ui/layouts/StickyFilterBar'
import { ControllingFilterBar } from './ui/ControllingFilterBar'
import { ControllingList } from './ui/ControllingList'
import { ControllingExportModal } from '../../../features/controlling/export'
import {
  useControllingFiltersParams,
  toControllingFiltersForm,
} from '../../../features/controlling/filters'

export const ControllingPage: React.FC = () => {
  const [params] = useControllingFiltersParams()
  const filters = toControllingFiltersForm(params)

  const [showPdfModal, setShowPdfModal] = useState(false)
  const [technicianLabel, setTechnicianLabel] = useState<string | null>(null)
  const [tradeLabel, setTradeLabel] = useState<string | null>(null)
  const [technicianTradeLabel, setTechnicianTradeLabel] = useState<string | null>(null)

  return (
    <PageLayout
      pageTitle="Controlling"
      primaryAction={{ label: 'Export', onClick: () => setShowPdfModal(true), }}
    >
      <div className="flex w-full flex-col gap-4">
        <StickyFilterBar>
          <ControllingFilterBar
            onTechnicianLabelChange={setTechnicianLabel}
            onTradeLabelChange={setTradeLabel}
            onTechnicianTradeLabelChange={setTechnicianTradeLabel}
          />
        </StickyFilterBar>
        <ControllingList />
      </div>

      <ControllingExportModal
        show={showPdfModal}
        onClose={() => setShowPdfModal(false)}
        filters={filters}
        technicianLabel={technicianLabel}
        tradeLabel={tradeLabel}
        technicianTradeLabel={technicianTradeLabel}
      />
    </PageLayout>
  )
}
